import { render, staticRenderFns } from "./RoomAmenities.vue?vue&type=template&id=3bebc549"
import script from "./RoomAmenities.vue?vue&type=script&lang=js"
export * from "./RoomAmenities.vue?vue&type=script&lang=js"
import style0 from "./RoomAmenities.vue?vue&type=style&index=0&id=3bebc549&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports